import { createAsyncThunk } from '@reduxjs/toolkit';
import { _giftCardUrls } from '@custom/Utils/constants/apiUrls';

const getGiftCardsApi = createAsyncThunk('getGiftCards', async () => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${_giftCardUrls.get}`
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default getGiftCardsApi;
